import React from 'react';
import { Link } from 'react-router';
import { Animated } from "react-animated-css";

class Card extends React.Component {
    render() {
        const { medal, index } = this.props,
            style = {
                width: 250,
                height: 250,
                background: medal.Background ? `url(${medal.Background}) no-repeat center center` : null,
                backgroundSize: medal.Background ? 'cover' : 'none',
                border: '1px solid white',
            };
        return (
            <Animated animationIn="fadeInRight" style={{ float: 'left' }} animationInDelay={50 * index}>
                <Link to={`/admin/medals/add/${medal.id}`}>
                    <figure className="card p-4 margin-right d-flex flex-column justify-content-center pointer hover-red" style={style}>
                        <img alt="" src={medal.Medal} className="align-self-center" style={{ width: 100, }} />
                        <span className="align-self-center font-18 text-center line1 margin-top-half anton toUpper black">{medal.Name}</span>
                    </figure>
                </Link>
            </Animated>
        )
    }
}

export default Card;


// WEBPACK FOOTER //
// ./src/components/private/medals/partials/card.js